<script>
    import { onMount } from 'svelte';
    import {spring, tweened} from 'svelte/motion';
    import Pie from './Pie.svelte';

    // Initial code
    let submitcode;
    let results;
    let code = searchParam('code');
    let percent = 0;
    const store = spring(0, {stiffness: 0.3, damping: 0.3});
    $: store.set(percent);

    // Comparison code
    let comparison_state = 'none';
    let comparison_submitcode;
    let comparison_results;
    let comparison_code = searchParam('comparison_code');
    let comparison_percent = 0;
    const comparison_store = spring(0, {stiffness: 0.3, damping: 0.3});
    $: comparison_store.set(comparison_percent);

    $: setCode(code, comparison_code);

    window.addEventListener('popstate', (state) => {
        code = state?.state?.code;
        comparison_code = state?.state?.comparison_code;
    });
    function searchParam(param) {
        return (new URL(document.location))?.searchParams?.get(param);
    }
    function setCode(value, comparison) {
        const url = new URL(window.location);
        let params = url.searchParams;
        const statechanged = (value != params.get("code") || comparison != params?.get("comparison_code"));

        if (value) {
            params?.set("code", value);
            getResults(value);
        } else {
            params?.delete("code");
            results = undefined;
        }

        if (comparison) {
            params?.set("comparison_code", comparison);
            getComparisonResults(comparison);
        } else {
            params?.delete("comparison_code");
            comparison_results = undefined;
            comparison_state = "none";
        }

        if (statechanged) {
            let state = {
                "code": value,
                "comparison_code": comparison
            };
            window.history.pushState(state, '', url);
        }
    }
    async function loadResults(code) {
        const response = await fetch('api/results', {
            method: "POST",
            body: JSON.stringify({ code: code })
        });
        return await response.json();
    }
    async function getResults(value, param) {
        results = await loadResults(value);
        percent = results.points / results.max_points * 100;
    }
    async function getComparisonResults(value, param) {
        comparison_state = 'loading';
        comparison_results = await loadResults(value);
        comparison_percent = comparison_results.points / comparison_results.max_points * 100;
        comparison_state = 'results';
    }
    function comparisonResponse(index) {
        return comparison_results.responses[index];
    }
    function autofocus(el) {
        if (!("autofocus" in document.createElement("input"))) {
            el.focus();
        }
    }
    function submitCode(event) {
        if (event.key === 'Enter') {
            code = submitcode.toUpperCase();
        }
    }
    function submitComparisonCode(event) {
        if (event.key === 'Enter') {
            comparison_code = comparison_submitcode.toUpperCase();
        }
    }
</script>

<main id="app">
{#if results}
  <div class="results content">
    <h1 class="title">Resultat</h1>
    <div class="result">
        <div class="code-box">
            <h2>Kod: {code}</h2>
        </div>
        <div class="box pie">
            <Pie size={260} percent={$store} text="{results.points} / {results.max_points}" />
        </div>
        <div class="box grade {results.grade.key}">
            <h2>{results.grade.title}</h2>
            <!-- <p>- {results.grade.description}</p> -->
        </div>
        <div class="actions">
            <div class="button-div">
                {#if !comparison_code}
                    <button on:click={() => (comparison_state = 'showform')} class="action-button compare-code-button"><img src="/images/compare-code.svg" class="compare-code-button" alt="Jämför kod" height="60px"></button>
                {/if}
                <button on:click={() => (code = undefined)} class="action-button reset-code-button"><img src="/images/arrow-change-code.svg" class="reset-code-img" alt="Byt kod" height="60px"></button>
            </div>
        </div>
    </div>
    {#if comparison_state == 'showform'}
        <div class="content">
            <h1>Fyll i kod för att jämföra resultat</h1>
            <div class="form-fields">
                <input type="text" bind:value={comparison_submitcode} on:keydown={submitComparisonCode} use:autofocus autofocus tabindex="1">
                <br>
                <button on:click={() => (comparison_code = comparison_submitcode.toUpperCase())} class="action-button compare-code-button"><img src="images/arrow-right.svg" alt="Jämför resultat" width="80px" height="80px"></button>
             </div>
        </div>
    {:else if comparison_state == 'loading'}
        <div class="content">
            <center><p>Laddar...</p></center>
        </div>
    {:else if comparison_state == 'results'}
        <div class="result comparison-result">
            <div class="code-box">
                <h2>Kod: {comparison_code}</h2>
            </div>
            <div class="box pie">
                <Pie size={260} percent={$comparison_store} text="{comparison_results.points} / {comparison_results.max_points}" />
            </div>
            <div class="box grade {comparison_results.grade.key}">
                <h2>{comparison_results.grade.title}</h2>
                <!-- <p>- {comparison_results.grade.description}</p> -->
            </div>
            <div class="actions">
                <div class="button-div">
                    <button on:click={() => (comparison_state = 'showform')} class="action-button change-compare-code-button"><img src="/images/arrow-change-code.svg" class="change-compare-code-img" alt="Change kod" height="60px"></button>
                </div>
            </div>
        </div>
        <div class="comparison-responses">
            {#each results.responses as response, index}
                <div class="comparison-box">
                    <div class="comparison-question">
                        <h2 class="question">{response.question}</h2>
                    </div>
                    <div class="comparison-response {response.job_ready ? "job-ready" : "rusta"}">
                        <h3 class="answer">Kod {code}</h3>
                        <p>Svar: {response.answer}</p>
                    </div>
                    <div class="comparison-response {comparisonResponse(index)?.job_ready ? "job-ready" : "rusta"}">
                        <h3 class="answer">Kod {comparison_code}</h3>
                        <p>Svar: {comparisonResponse(index)?.answer || "-"}</p>
                    </div>
                    <!--
                    <div class="comparison-action-point">
                        <h4>Action point:</h4>
                        <p>{response.action_point}</p>
                    </div>
                    <div class="comparison-action-point">
                        <h4>Action point:</h4>
                        <p>{comparisonResponse(index)?.action_point || "-"}</p>
                    </div>
                    -->
                </div>
            {/each}
        </div>
    {:else}
        <div class="responses">
            {#each results.responses as response}
                <div class="box response {response.job_ready ? "job-ready" : "rusta"}">
                    <h2 class="question">{response.question}</h2>
                    <h3 class="answer">Svar:<br>{response.answer}</h3>
                    <!-- <p>{response.action_point}</p> -->
                </div>
            {/each}
        </div>
    {/if}

  </div>
{:else if code}
  <div class="content">
    <center><p>Laddar...</p></center>
  </div>
{:else}
  <div class="content">
    <h1>Fyll i kod för att visa resultat</h1>
    <div class="form-fields">
        <input type="text" bind:value={submitcode} on:keydown={submitCode} use:autofocus autofocus tabindex="1">
        <br>
        <button on:click={() => (code = submitcode.toUpperCase())} class="action-button button-result"><img src="images/arrow-right.svg" alt="Visa resultat" width="80px" height="80px"></button>
     </div>
  </div>
{/if}
</main>

<style>
#app {
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
  max-width: 1200px;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

h1.title {
  text-decoration: underline;
}

h1 {
  padding: 1rem;
  text-align: center;
  color: #1d1d1b;
  font-weight: 900;
  font-size: 2rem;
  text-align: center;
}

h2 {
  font-size: 1.2rem;
}

h3 {
  font-size: 1.0rem;
}

h4 {
  font-size: 0.8rem;
  font-weight: lighter;
  margin: 0;
}

p {
  font-weight: 100;
  font-size: 1.0rem;
  font-family: HelveticaNeueThin, sans-serif;
}

.actions {
  max-width: 30rem;
  width: 260px;
  padding-right: 1rem;
  padding-bottom: calc(1rem - 7px);
}

.result .actions {
  display: flex;
  align-items: flex-end;
  flex-direction: row;
}

.result .actions > button {
  margin-right: 0;
}

.comparison-result {
  background-color: #fcbb93;
  padding-top: 1rem;
}

input {
  color: #1d1d1b;
  padding: 0.5em;
  text-align: center;
  font-size: 1.5em;
  margin-bottom: 0.5em;
  border-width: 0 0 2px 0;
  border-style: solid;
  border-color: #1d1d1b;
}

input:focus {
  outline: none;
}

.result {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  max-width: 1140px;
  width: 100%;
}

.result > .box {
  margin: 0 1rem 1rem 1rem;
}

.result > .box.pie {
    padding: 0;
}

.comparison-responses,
.responses {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.comparison-box {
  min-height: 340px;
  max-width: 560px;
  text-align: left;
  margin: 20px 10px 0 10px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.comparison-box h2,
.comparison-box h3,
.comparison-box h4 {
  margin: 0;
}

.comparison-box p {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.comparison-question {
  background-color: #23b6df;
  padding: 10px;
  min-height: 80px;
  flex-grow: 2;
  width: 100%;
}

.comparison-response {
  padding: 10px;
  min-height: 130px;
  max-width: 260px;
  flex-grow: 1;
}

.comparison-action-point {
  background-color: #fcbb93;
  padding: 10px;
  min-height: 130px;
  max-width: 260px;
  flex-grow: 1;
}

.code-box {
  width: 200px;
  margin-left: 1rem;
}

.code-box h2 {
  background-color: #ffe651;
  padding: 0.5rem;
  text-decoration: underline;
  margin-top: 0;
}

.box {
  min-height: 260px;
  width: 260px;
  padding: 0 12px 12px 12px;
  text-align: left;
}

.box h2 {
  margin-top: 12px;
}

.job-ready {
  background: #1bc76a;
}
.rusta {
  background: #f55036;
}

.box.grade {
  display: flex;
  flex-direction: column;
}

.form-fields {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.button-div {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: 100%;
}

.action-button {
  padding: 0;
  background: none;
  border: none;
  outline: none;
  color: #1d1d1b;
  cursor: pointer;
}

.action-button img {
  transition: all 0.1s ease-out;
}

.result-button {
  width: 120px;
  height: 120px;
}

.result-button img:hover {
  width: 90px;
  height: 90px;
}
</style>
